import { useCallback, useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';

/**
 * @param {{ dataTour?: string }} [props]
 */
export function NotificationPreferencesSection({ dataTour }) {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    apiJson('/api/notifications/preferences')
      .then((data) => setTypes(data.types || []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const toggle = (index, field) => {
    setTypes((rows) =>
      rows.map((row, i) => (i === index ? { ...row, [field]: !row[field] } : row)),
    );
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setMsg('');
    try {
      const data = await apiJson('/api/notifications/preferences', {
        method: 'PUT',
        body: {
          preferences: types.map(({ type, email_enabled, push_enabled }) => ({
            type,
            email_enabled,
            push_enabled,
          })),
        },
      });
      setTypes(data.types || []);
      setMsg('Notification settings saved.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p className="muted">Loading notification settings…</p>;
  }

  if (types.length === 0) {
    return null;
  }

  return (
    <form
      onSubmit={save}
      className="auth-card flat stack"
      style={{ marginTop: '1rem' }}
      data-tour={dataTour || undefined}
    >
      <h3>Notifications</h3>
      <p className="muted small" style={{ marginTop: 0 }}>
        Choose how you want to be notified for each event. Push alerts appear in the bell menu on the site.
      </p>
      {error ? <p className="err">{error}</p> : null}
      {msg ? <p className="muted">{msg}</p> : null}
      <div className="notif-prefs-table">
        <div className="notif-prefs-head">
          <span>Event</span>
          <span>Email</span>
          <span>Push</span>
        </div>
        {types.map((row, index) => (
          <div key={row.type} className="notif-prefs-row">
            <div>
              <strong>{row.label}</strong>
              <div className="muted small">{row.description}</div>
            </div>
            <label className="notif-prefs-check">
              <input
                type="checkbox"
                checked={!!row.email_enabled}
                onChange={() => toggle(index, 'email_enabled')}
              />
            </label>
            <label className="notif-prefs-check">
              <input
                type="checkbox"
                checked={!!row.push_enabled}
                onChange={() => toggle(index, 'push_enabled')}
              />
            </label>
          </div>
        ))}
      </div>
      <button type="submit" className="btn-primary" disabled={saving}>
        {saving ? 'Saving…' : 'Save notification settings'}
      </button>
    </form>
  );
}
